import { render, staticRenderFns } from "./achievement-table.vue?vue&type=template&id=03050956"
import script from "./achievement-table.vue?vue&type=script&lang=js"
export * from "./achievement-table.vue?vue&type=script&lang=js"
import style0 from "./achievement-table.vue?vue&type=style&index=0&id=03050956&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports